import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { PAYMENT_MANAGE_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const paymentServiceApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: PAYMENT_MANAGE_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: ["GetAllPayment", "CompanyDetails"],
  keepUnusedDataFor: 30,
  endpoints: () => ({}),
});
